import React, { useEffect, useRef } from 'react';

const PersonalCanvas = ({
    canvasVideoRef,
    hiddenCanvasStyle,
    toolboxMode,
    textCanvasRef,
    imageCanvasRef,
    drawCanvasRef,
    eraseCanvasRef,
    compositeCanvasRef,
    handleStartDrawing,
    handleDraw,
    handleStopDrawing,
    doErasing,
    isSendingScreenShot
}) => {
    const containerRef = useRef(null);

    // Set canvas internal dimensions to match the container on mount
    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;
        const w = container.offsetWidth;
        const h = container.offsetHeight;
        [canvasVideoRef, textCanvasRef, imageCanvasRef, drawCanvasRef, eraseCanvasRef, compositeCanvasRef]
            .forEach(ref => {
                if (ref?.current) {
                    ref.current.width = w;
                    ref.current.height = h;
                }
            });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div ref={containerRef} style={{ position: 'relative', margin: 'auto', width: '320px', height: '240px', background: '#fff' }}>
            <canvas
                id="canvasVideoRef"
                ref={canvasVideoRef}
                style={{ ...hiddenCanvasStyle, zIndex: 1, pointerEvents: 'none' }}
            />

            <canvas
                id="textCanvasRef"
                ref={textCanvasRef}
                style={{
                    ...hiddenCanvasStyle,
                    zIndex: toolboxMode === 'text' ? 4 : 2,
                    pointerEvents: toolboxMode === 'text' ? 'auto' : 'none',
                }}
            />

            <canvas
                id="imageCanvasRef"
                ref={imageCanvasRef}
                style={{
                    ...hiddenCanvasStyle,
                    zIndex: 3,
                    pointerEvents: toolboxMode === 'imageAndIcons' ? 'auto' : 'none',
                }}
            />

            <canvas
                id="drawCanvasRef"
                ref={drawCanvasRef}
                onMouseDown={(e) => { e.nativeEvent.stopPropagation(); handleStartDrawing(e); }}
                onMouseMove={handleDraw}
                onMouseUp={handleStopDrawing}
                onMouseLeave={handleStopDrawing}
                style={{
                    ...hiddenCanvasStyle,
                    zIndex: 4,
                    pointerEvents: toolboxMode === 'draw' ? 'auto' : 'none',
                }}
            />

            <canvas
                id="eraseCanvasRef"
                ref={eraseCanvasRef}
                onMouseDown={(e) => { e.nativeEvent.stopPropagation(); handleStartDrawing(e); }}
                onMouseMove={doErasing}
                onMouseUp={handleStopDrawing}
                onMouseLeave={handleStopDrawing}
                style={{
                    ...hiddenCanvasStyle,
                    zIndex: toolboxMode === 'erase' ? 4 : 2,
                    pointerEvents: toolboxMode === 'erase' ? 'auto' : 'none',
                }}
            />

            <canvas
                id="compositeCanvasRef"
                ref={compositeCanvasRef}
                style={{
                    ...hiddenCanvasStyle,
                    zIndex: 5,
                    pointerEvents: 'none',
                    display: isSendingScreenShot ? 'block' : 'none'
                }}
            />
        </div>
    );
};

export default PersonalCanvas;